import { useApiQuery } from "../../../common/infrastructure/hooks/useApiQuery";
import { endpointsMetadata } from "../../../common/infrastructure/routes/endpointsMetadata";
import { PlanCard, PlanCardSkeleton } from "./components/PlanCard";
import { IMyPlanViewModel } from "./models/MyPlanViewModel";
import styles from "./MyPlans.module.scss";

export const MyPlans = () => {
  const { data: plans, isLoading } = useApiQuery<IMyPlanViewModel[]>({
    queryKey: [endpointsMetadata.myPlans.getAll],
    endpoint: endpointsMetadata.myPlans.getAll,
    globalIsLoading: false,
  });

  if (!plans?.length && !isLoading) {
    return (
      <div className={styles.empty_state}>
        <p>Нямате активни планове.</p>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <h1 className={styles.title}>Моите планове</h1>
      <div className={styles.grid}>
        {isLoading
          ? Array(3)
              .fill(0)
              .map((_, index) => <PlanCardSkeleton key={index} />)
          : plans?.map((plan) => <PlanCard key={plan.id} plan={plan} />)}
      </div>
    </div>
  );
};
